module.exports = __webpack_public_path__ + "static/img/bg.7283328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 13 14